const visitRequiredFields = {

  install (Vue, options) {
    Vue.prototype.VisitRequiredFields = {
      DOCTOR: "doctor",
      ROOM: "room"
    }
  }
}

export default visitRequiredFields



// WEBPACK FOOTER //
// ./src/constants/visitRequiredFields.js